// pattern-utils.ts
import * as pattern from 'patternomaly';

type PatternType =
  | 'diagonal'
  | 'dot'
  | 'cross'
  | 'zigzag'
  | 'diamond'
  | 'triangle'
  | 'plus'
  | 'dash'
  | 'cross-dash'
  | 'dot-dash'
  | 'disc'
  | 'ring'
  | 'line'
  | 'line-vertical'
  | 'weave'
  | 'zigzag-vertical'
  | 'triangle-inverted'
  | 'diamond-box'
  | 'box';

// Safe list of available patterns from patternomaly
const AVAILABLE_PATTERNS: PatternType[] = [
  'diagonal',
  'dot',
  'cross',
  'zigzag',
  'diamond',
  'triangle',
  'plus',
  'dash',
  'cross-dash',
  'dot-dash',
  'disc',
  'ring',
  'line',
  'line-vertical',
  'weave',
  'zigzag-vertical',
  'triangle-inverted',
  'diamond-box',
  'box'
];

// Default color palette (expand as needed)
const COLORS: string[] = [
  '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728',
  '#9467bd', '#8c564b', '#e377c2', '#7f7f7f',
  '#bcbd22', '#17becf'
];

/**
 * Generate accessible patterns for a given dataset length
 */
export function generateAccessiblePatterns(count: number): CanvasPattern[] {
  const patterns: CanvasPattern[] = [];

  for (let i = 0; i < count; i++) {
    const patternType = AVAILABLE_PATTERNS[i % AVAILABLE_PATTERNS.length];
    const color = COLORS[i % COLORS.length];
    patterns.push(pattern.draw(patternType, color));
  }

  return patterns;
}
